import * as React from 'react'
import Layout from '../../components/Layout'
import { graphql, Link } from 'gatsby'
import Img from 'gatsby-image'

import CTA from '../../components/CTA'

import {
  Announcement,
  Container,
  Hero,
  HeroContent,
  HeroFigure,
  HeroMain,
  Text
} from '../../components/styles'
import { Button } from '../../components/Button'

import Form from '../../components/Form'
import Arrow from '../../components/Arrow'
import { Helmet } from 'react-helmet'

/* prettier-ignore */
interface IProps {
  data: {
    hero: {
      childImageSharp: {
        fluid: object
      }
    };
  }
}

export default ({ data }: IProps) => (
  <Layout>
    <Helmet>
      <title>
        Brisbane Web Hosting - Hosting & Management Solutions - Turboclicks
      </title>
      <meta
        name="description"
        content="Make your list simple so you can do what you do best. Contact us about our fully managed web hosting solutions today."
      />
    </Helmet>
    <Hero>
      <Container>
        <HeroContent>
          <HeroMain>
            <h1>Brisbane web hosting</h1>
            <p>
              Make your hosting simple so you can do what you do best. Contact
              us about our fully managed web hosting solutions today.
            </p>
            <Announcement to="/contact">
              Speak with our team
              <Arrow rotate="-90deg" />
            </Announcement>
            <Link to="/contact#form">
              <Button inverted={true}>Get a quote today</Button>
            </Link>
          </HeroMain>

          <HeroFigure>
            <Img
              fluid={data.hero.childImageSharp.fluid}
              alt="Turboclicks website development in Brisbane"
            />
          </HeroFigure>
        </HeroContent>
      </Container>
    </Hero>

    <CTA
      inverted={true}
      title="See how we can help you"
      subtitle="Get a quote today"
      button="Speak to our team"
    />

    <Container padY={true} medium={true}>
      <h3>You need a good web server</h3>

      <h5>Quick</h5>
      <Text size="large">
        When it comes to the internet. Speed is 50% of the equation. If your
        users can't load your site, you have zero chance of converting them into
        a paying customer. All our servers are located right here in Australia,
        with caches and content delivery networks at "edge nodes" all around the
        country and world. Our average response time is faster than Google's.
      </Text>

      <h5>Reliable</h5>
      <Text size="large">
        Every minute your website is down, you could be losing customers and
        money. We have a 99.99% uptime track record and guarantee, you can have
        absolute trust that your website is working for you and your business.
      </Text>

      <h5>Capable</h5>
      <Text size="large">
        Let's be real. You don't want to be managing the details yourself. Let
        us take care of the details. On top of this, our hosting guarantees
        immediate access to a team of developers and programmers who can cater
        to you individual business needs.
      </Text>

      <h5>Secure</h5>
      <Text size="large">
        The last thing you want is to find our your customers details have been
        compromised, or your website has been hacked. We know the ins and outs
        of best practice cryptography, frontend and server security.
      </Text>
      <Text size="large">
        On top of this, our distributed backup system means that no matter what
        happens in the evolving world your data will be safe.
      </Text>
    </Container>

    <Form />
  </Layout>
)

export const query = graphql`
  query WebHostingPageQuery {
    hero: file(relativePath: { eq: "server-room-hosting-turboclicks.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
  }
`
